var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureDataBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.212,
    height: 50.384,
    viewBox: "0 0 47.212 50.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_167044",
    x: 0,
    y: 0,
    width: 47.212,
    height: 50.384,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Secure_Badge",
    "data-name": "Secure Badge",
    transform: "translate(-326.12 -181.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield-fill",
    transform: "translate(335.883 188.238)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.76, -6.75)",
    filter: "url(#Path_167044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167044-2",
    "data-name": "Path 167044",
    d: "M10.924,2.206a27.608,27.608,0,0,1,5.792-1.081,27.628,27.628,0,0,1,5.792,1.081q2.873.772,5.707,1.678a3,3,0,0,1,2.065,2.438A24.943,24.943,0,0,1,25.406,25.6a23.041,23.041,0,0,1-4.979,4.736,14.294,14.294,0,0,1-2.074,1.207,4.277,4.277,0,0,1-1.639.463,4.277,4.277,0,0,1-1.639-.463A14.223,14.223,0,0,1,13,30.339,23.043,23.043,0,0,1,8.026,25.6,24.932,24.932,0,0,1,3.151,6.322,2.994,2.994,0,0,1,5.216,3.884q2.833-.906,5.707-1.678Z",
    transform: "translate(6.89 5.63)",
    fill: "#fff",
    stroke: "#002f6c",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "lock-closed",
    d: "M16.9,8.385h-.626V6.118a3.759,3.759,0,0,0-7.517,0V8.385H8.131a2.508,2.508,0,0,0-2.506,2.506v6.89a2.508,2.508,0,0,0,2.506,2.506H16.9a2.508,2.508,0,0,0,2.506-2.506v-6.89A2.508,2.508,0,0,0,16.9,8.385Zm-1.879,0H10.01V6.118a2.506,2.506,0,0,1,5.011,0Z",
    transform: "translate(337.211 190.062)",
    fill: "#002f6c",
    stroke: "#002f6c",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check",
    d: "M18.168,12.882l-.63-.634a.137.137,0,0,0-.1-.042h0a.131.131,0,0,0-.1.042l-4.365,4.306L11.385,15a.14.14,0,0,0-.2,0l-.637.624a.138.138,0,0,0,0,.2l2,1.962a.639.639,0,0,0,.419.2.669.669,0,0,0,.415-.193h0l4.783-4.709A.147.147,0,0,0,18.168,12.882Z",
    transform: "translate(335.369 189.178)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureDataBadge);
export default __webpack_public_path__ + "static/media/secure-data-badge.834b6688e99ae1934465c0d8f4528782.svg";
export { ForwardRef as ReactComponent };